<template>
  <div class="bg-F6F6F6 height-full fb fb-col">
    <div class="bg-FFFFFF">
      <div class="bb pb-4">
        <md-tabbar
          v-model="tabIndex"
          indicatorColor="#171A1D"
          :fixed="tabList.length < 4"
        >
          <md-tabbar-item
            v-for="item in tabList"
            :key="item.id"
            :name="item.id"
          >
            {{ item.name }}({{ mealStastics[item.countText] }})
          </md-tabbar-item>
        </md-tabbar>
      </div>

      <div
        v-if="cpAtSchoolFlag"
        class="p-0-16 lh-48 h-48 nowrap w-full scroll-x"
      >
        <span
          @click="handlerChangeTag(item)"
          v-for="(item, index) in tagList"
          :key="`tag${index}`"
          class="font-28 text-center inline-block ff-regular lh-30 h-30 p-0-12 mr-16 bd-radio-4"
          :class="
            tagIndex === item.id
              ? 'bg-006AFE c-FFFFFF'
              : 'bg-191F25-8 c-171A1D-40'
          "
          >{{ item.name
          }}<span v-show="item.id"
            >({{ mealStastics[item.countText] }})</span
          ></span
        >
      </div>
      <div v-if="cpCardFlag" class="p-0-16 lh-48 h-48 nowrap w-full scroll-x">
        <span
          @click="dinnerIndex = item.id"
          v-for="(item, index) in dinnerList"
          :key="`dinner${index}`"
          class="font-28 text-center inline-block ff-regular lh-30 h-30 p-0-12 mr-16 bd-radio-4"
          :class="
            dinnerIndex === item.id
              ? 'bg-006AFE c-FFFFFF'
              : 'bg-191F25-8 c-171A1D-40'
          "
          >{{ item.name }}</span
        >
      </div>
    </div>
    <div
      class="item-flex-1 scroll mt-12"
      @scroll="handlerLoadingDetailMore"
      v-if="detailList && detailList.length"
    >
      <div
        class="font-24 bg-FFFFFF pb-10 mb-12"
        v-for="(item, index) in detailList"
        :key="index"
      >
        <div class="c-171A1D-56 p-0-16 lh-20 p-8-0">{{ item.className }}</div>
        <studentHead
          v-for="(user, index) in item.studentInfos"
          :key="index"
          :student-info="user"
          show-padding-left
          show-all-class
          show-line
          max-width="300"
          @click="handlerClickDetail"
        ></studentHead>
      </div>
    </div>
    <div v-else class="w-fullVw item-flex-1 relative" style="min-height: 216px">
      <common-no-data class="no-record">
        <div class="no-item"></div>
        <p class="font-28 c-171A1D-40">当天暂无记录</p>
      </common-no-data>
    </div>
  </div>
</template>

<script>
import commonNoData from './commonNoData'
import studentHead from './studentHead'
import { LEAVE_ROLE } from '@/utils/constUtils'
import { timeFormat } from '@/utils/comUtils'
import mixin from '@/mixin'
import API from '@/api'
export default {
  mixins: [mixin],
  name: '',
  components: { commonNoData, studentHead },
  props: {
    date: {
      type: String,
      default: timeFormat(new Date(), 'YYYY-MM-DD')
    },
    stateId: {
      type: Number,
      default: 1
    },
    // 3 管理员 2 班主任
    headerTabId: {
      type: Number,
      default: 1
    },
    // 1 午餐 2 晚餐
    mealTabId: {
      type: Number,
      default: 1
    },
    curClassId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tabIndex: +this.stateId,
      tabList: [
        {
          id: 1,
          name: '待确认',
          countText: 'unConfirmedCount'
        },
        {
          id: 2,
          name: '已吃饭',
          countText: 'eatenCount'
        },
        {
          id: 3,
          name: '未吃饭',
          countText: 'notEatenCount'
        },
        {
          id: 4,
          name: '请假',
          countText: 'leaveCount'
        }
      ],
      tagList: [
        {
          id: '',
          name: '全部',
          countText: 'all'
        },
        {
          id: 1,
          name: '在校',
          countText: 'inSchoolCount'
        },
        {
          id: 2,
          name: '不在校',
          countText: 'outSchoolCount'
        }
      ],
      dinnerList: [
        {
          id: '',
          name: '全部',
          countText: 'all'
        },
        {
          id: 1,
          name: '已刷卡',
          countText: 'atSchool'
        },
        {
          id: 2,
          name: '未刷卡',
          countText: 'notAtSchool'
        }
      ],
      tabObj: {},
      tagIndex: '',
      dinnerIndex: '',
      detailList: [],
      isLoadDetailMore: true,
      pageNum: 1,
      pageSize: 20,
      noNeedCheckStatus: '',
      showLoading: null,
      mealStastics: {}
    }
  },
  computed: {
    cpFetchFlag() {
      return `${this.headerTabId}${this.mealTabId}${this.date}${this.curClassId}`
    },
    cpRecordFlag() {
      return `${this.headerTabId}${this.mealTabId}${this.date}${this.curClassId}${this.dinnerIndex}${this.tabIndex}`
    },
    cpAtSchoolFlag() {
      return this.tabIndex === 1
    },
    cpCardFlag() {
      return this.mealTabId === 2 && +this.tabIndex === 2
    }
  },
  watch: {
    cpFetchFlag: {
      handler() {
        this.fetchStatistics()
      },
      immediate: true
    },
    cpRecordFlag() {
      this.handlerChangeState(true)
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.showLoading = this.$Toast({
      type: 'loading',
      duration: 9000,
      content: '加载中···'
    })
    setTimeout(() => {
      this.initTabList()
    }, 100)
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // 初始化tab
    initTabList() {
      let _tabId = this.tabList.map(item => {
        return item.id
      })
      this.tabIndex =
        _tabId.indexOf(+this.tabIndex) > -1 ? this.tabIndex : _tabId[0]
      this.handlerChangeState()
    },
    // 切换状态 (状态，是否是滚动，是否是初始化, 初始化标签)
    handlerChangeState() {
      this.pageNum = 1
      this.fetchData(true)
    },
    // 加载更多
    handlerLoadingDetailMore(e) {
      let _el = e.currentTarget
      if (
        _el.scrollTop + _el.clientHeight + 20 >= _el.scrollHeight &&
        this.isLoadDetailMore
      ) {
        this.isLoadDetailMore = false
        ++this.pageNum
        this.fetchData()
      }
    },
    // 切换标签
    handlerChangeTag(item) {
      this.tagIndex = item.id
      this.initTabList()
    },
    // 跳转详情
    handlerClickDetail(studentInfo) {
      this.$router.push({
        path: '/meal/calendar',
        query: {
          studentDingId: studentInfo.dingUserId || studentInfo.studentDingId,
          date: this.date
        }
      })
    },
    async fetchStatistics() {
      const param = {
        ...this.commonParams,
        operUserRoleTypes: this.headerTabId,
        dimDay: this.date.replace(/\/|-/gi, ''),
        mealType: this.mealTabId
      }
      if (this.headerTabId === LEAVE_ROLE.headmaster) {
        param.classId = this.curClassId
      }
      try {
        this.mealStastics = await API.getMealAllClassMealStatistics(param)
      } catch (error) {}
    },
    async fetchData(init) {
      const param = {
        ...this.commonParams,
        operUserRoleTypes: this.headerTabId,
        dimDay: this.date.replace(/\/|-/gi, ''),
        mealStatus: this.tabIndex, // 学生就餐状态 1-待确认 2-已吃饭 3-未吃饭 4-请假
        mealType: this.mealTabId, // 查询就餐类型，1午餐，2晚餐
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      if (this.cpAtSchoolFlag) {
        param.accessStatus = this.tagIndex // 学生在校状态 1-在校 2-离校
      }
      if (this.cpCardFlag) {
        param.cardStatus = this.dinnerIndex // 学生刷卡状态 1-已刷卡 2-未刷卡
      }
      if (this.headerTabId === LEAVE_ROLE.headmaster) {
        param.classId = this.curClassId
      }
      try {
        let stasticsData = await API.getMealStudentListByMealStatus(param)
        const detailList = init
          ? stasticsData.data
          : this.detailList.concat(stasticsData.data || [])
        this.isLoadDetailMore =
          stasticsData.total / this.pageSize > this.pageNum
        this.detailList = detailList.map(item => {
          return {
            ...item,
            studentInfos: item.studentInfos.map(itm => {
              return {
                ...itm,
                userName: itm.studentDingName
              }
            })
          }
        })
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-x {
  overflow-x: scroll;
}
.pt-110 {
  padding-top: 110px;
}
.no-record {
  .no-item {
    width: 180px;
    height: 180px;
    background: url(~@/assets/images/no-data.png) no-repeat center center;
    background-size: 100% 100%;
  }
}
</style>
